const Genesis = require("../Genesis.js")
import { post } from "jquery";
let GhostUserAutoComplete = require("./GhostMode.js");

export class ISiteMobileGhostModeIndexPage {

    constructor() {

    }

    public Init() {
        GhostUserAutoComplete();


        $("#btn-Submit").click((e: any) => {
            $.get("GhostMode/SetGhostUser",
                {
                    UserId: $("#hdnGhostedUserId").val(),
                    Username: $("#hdnGhostedUserName").val()
                }, function (responseResult) {
                    if (responseResult.result == "Success") {
                        window.location.href = Genesis.url(responseResult.redirectUrl);
                    }
                });
        });

        $(".clearSearch").click((e: any) => {
            $("#hdnGhostedUserId").val(0);
            $("#hdnGhostedUserName").val("");
            $("#userLookupSearch").val("");
        });
    }
}